import { FC } from 'react';
import { parseISO, format } from 'date-fns';
import Link from 'next/link';
import { ISearchAuthorData } from '@/interfaces/authorsPage.interface';
import { getAuthorFullName } from '@/helpers/helpers';
import styles from './AuthorsList.module.scss';

interface IAuthorsListLetter {
  data: ISearchAuthorData[];
}

const AuthorsListLetter: FC<IAuthorsListLetter> = ({ data }) => {
  return (
    <ul className={styles.authorsList}>
      {data.map((author) => (
        <li key={author.id} className={styles.authorsList__item}>
          <Link prefetch={false} href={`/authors/${author.alias}`} className={styles.authorsList__name}>
            {getAuthorFullName(String(author.first_name ?? ''), String(author.middle_name ?? ''), String(author.last_name ?? ''))}
          </Link>
        </li>
      ))}
    </ul>
  );
};
export default AuthorsListLetter;
